export interface IFollowUpSurveyForList {
    id: number,
    editKey: string,
    centerId: number,
    centerAlias: string,
    firstName: string,
    lastName: string,
    birthDate: string,
    city: string,
    state: string,
    surveyInitiatedDateTime: string,
    donationDate: string,
    surveyInstanceId: number,
    surveyInstance: string,
    complianceDueDate: string,
    complianceDaysLeft: number,
    isLate: boolean,
    isAlmostLate: boolean,
    statusId: number,
    status: string,
    hasRegrets: boolean,
    areLabResultsGood: boolean,
    isNotifiedOfLabResults: boolean,
    isReviewed: boolean,
    dashDomain: string,
}